import React, { PureComponent } from 'react';
import styles from './index.css';
import { h5PageCount } from '../../../utils';
import { callApp } from '@ifeng/callapp';
class WXGuideLayer extends PureComponent {
    constructor(props) {
        super(props);
        this.handleCallApp = () => {
            const { callAppConfig, clickCallAppConfig } = this.props;
            if (clickCallAppConfig) {
                h5PageCount([clickCallAppConfig]);
            }
            if (callAppConfig) {
                callApp(callAppConfig);
            }
        };
        this.closeLayer = () => {
            const { clickContinueConfig } = this.props;
            this.setState({
                isShowLayer: false
            });
            if (clickContinueConfig) {
                // 关闭统计
                h5PageCount([clickContinueConfig]);
            }
            document.body.style.position = '';
            document.body.style.top = '';
        };
        const userAgentStr = (typeof navigator === 'object' && navigator.userAgent && navigator.userAgent.toLocaleLowerCase()) || '';
        if (userAgentStr.indexOf('micromessenger') !== -1) {
            this.state = {
                isShowLayer: true,
            };
        }
        else {
            this.state = {
                isShowLayer: false,
            };
        }
    }
    componentDidMount() {
        const { isShowLayer } = this.state;
        if (isShowLayer) {
            document.body.style.position = 'fixed';
            document.body.style.top = '0';
        }
    }
    render() {
        const { isShowLayer } = this.state;
        return (isShowLayer && React.createElement("div", { className: styles.guideLayer },
            React.createElement("div", { className: styles.guideMenu },
                React.createElement("h2", { className: styles.guideMenuTip }, "\u7EE7\u7EED\u6D4F\u89C8\u7CBE\u5F69\u5185\u5BB9"),
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("img", { className: styles.guideMenuIcon, src: "https://x0.ifengimg.com/ucms/2020_47/72D5F2C83657D87D6027573A0E523497387BBC5E_w144_h144.png" }),
                    React.createElement("div", { className: styles.guideMenuInfo },
                        React.createElement("h2", { className: styles.guideMenuName }, "\u51E4\u51F0\u65B0\u95FB"),
                        React.createElement("p", { className: styles.guideMenuBref }, "\u5168\u7403\u70ED\u70B9\u4E00\u7F51\u6253\u5C3D")),
                    React.createElement("img", { className: styles.guideMenuButton, onClick: this.handleCallApp, src: "https://x0.ifengimg.com/ucms/2020_47/25F9C4EBDD935FBE7F2D606CEF7D6310DA5F9FCC_w228_h96.png" })),
                React.createElement("div", { className: styles.guideMenuItem },
                    React.createElement("img", { className: styles.guideMenuIcon, src: "https://x0.ifengimg.com/ucms/2020_47/AA88E2014B5D3F03CBA1CD4497F8717084163828_w144_h144.png" }),
                    React.createElement("div", { className: styles.guideMenuInfo },
                        React.createElement("h2", { className: styles.guideMenuName }, "\u5FAE\u4FE1")),
                    React.createElement("img", { className: styles.guideMenuButton, onClick: this.closeLayer, src: "https://x0.ifengimg.com/ucms/2020_47/1A9CA5465B6A964119B212FF0C02D37460038204_w228_h96.png" })))));
    }
}
export default WXGuideLayer;
